import { startCase } from 'lodash-es';

import { DropdownMenuItem } from 'src/common/DropdownMenu/DropdownMenuItem';
import { DropdownMenuSeparator } from 'src/common/DropdownMenu/DropdownMenuSeparator';
import { DropdownSubmenu } from 'src/common/DropdownMenu/DropdownSubmenu';
import { OverrideStatusEnum } from 'src/common/external/bambi-api/bambiApi';

import { CANCEL_REASONS } from './DispatchCalendar/TripCalendarEvent/EventMenu/cancellationReasons';
import { useTripMenuActions } from './DispatchCalendar/useTripMenuActions';

interface Props {
  trip: {
    id: string;
    status: OverrideStatusEnum;
  };
}

export function CancellationMenu({ trip }: Props) {
  const menuActions = useTripMenuActions();

  return (
    <>
      {trip.status === 'canceled' ? (
        <DropdownMenuItem onClick={() => menuActions.uncancel(trip.id)}>
          Uncancel
        </DropdownMenuItem>
      ) : (
        <DropdownSubmenu triggerText="Cancel">
          <DropdownMenuItem>Please select reason</DropdownMenuItem>
          <DropdownMenuSeparator />
          {CANCEL_REASONS.map((reason) => {
            return (
              <DropdownMenuItem
                key={reason}
                onClick={() => menuActions.cancel(trip.id, reason)}
              >
                {startCase(reason)}
              </DropdownMenuItem>
            );
          })}
        </DropdownSubmenu>
      )}
    </>
  );
}
